import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AppStoreModel, APP_STATE_TOKEN } from '@app/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-section-home-banner',
  templateUrl: './section-home-banner.component.html',
  styleUrls: ['./section-home-banner.component.scss']
})
export class SectionHomeBannerComponent implements OnInit {

  @ViewChild('videoPlayer', { static: false }) videoplayer: ElementRef;

  mostrarBannerDefault: boolean;

  @Select(APP_STATE_TOKEN) appState$: Observable<AppStoreModel>;

  constructor(
  ) {


  }

  // playVideo = <any>setTimeout(() => {
  //   var promise = this.videoplayer.nativeElement.play();

  //   if (promise !== undefined) {
  //     promise.then(_ => {
  //     }).catch(error => {
  //       this.mostrarBannerDefault = true;
  //     });
  //   }
  // }, 300);

  ngOnInit() {
    this.mostrarBannerDefault = true;
  }

}
